import React, { useEffect, useState } from 'react';
import './ProjectInfo.css';
import AddressDisplay from '../addressdisplay/AddressDisplay';
import { logNow } from '../../utils';
import { AiOutlineSafetyCertificate   } from "react-icons/ai";
import { PiTelegramLogoLight } from "react-icons/pi";
import UnlistedLogo from '../../assets/unlisted-logo.png';
import UnlistedBanner from '../../assets/unlisted-banner.png';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { AiOutlineStop } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri";
import { TbWorldWww } from "react-icons/tb";
import { TokenItem } from '../../utils/types';
import { MdVerified } from "react-icons/md";
import { PiFingerprint } from "react-icons/pi";

const KYC = PiFingerprint  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Verified = MdVerified  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const InfoIcon = AiOutlineInfoCircle  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const UnlistedIcon = AiOutlineStop  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TimesIcon = AiOutlineSafetyCertificate  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = PiTelegramLogoLight  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const X = RiTwitterXFill  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const WWW = TbWorldWww  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface ProjectInfoProps {
  data: any;
  priceData: any;
  scanData: any;
  ca: any;
  chainId?: any;
  pairAddress?: any;
  projectDb: TokenItem[];
}

const ProjectInfo: React.FC<ProjectInfoProps> = ({ data, priceData, scanData, ca, chainId, projectDb, pairAddress }) => {
  const [price, setPrice] = useState<any>(null);
  const [change, setChange] = useState<any>(null);
  const [verified, setVerified] = useState<any>(false);
  const [scanDatas, setScanData] = useState<any>(null);
  const [bannerURL, setBannerURL] = useState<any>(null);
  const [logoURL, setLogoURL] = useState<any>(null);
  const [logoFormat, setLogoFormat] = useState<any>(null);
  const [isListed, setIsListed] = useState<any>(null);
  const [badges, setBadges] = useState<any>(null);
  const [description, setDescription] = useState<any>(null);
  const [title, setTitle] = useState<any>(null);
  const [symbol, setSymbol] = useState<any>(null);
  const [descExpanded, setDescExpanded] = useState(false);

  useEffect(() => {
    if (data && priceData) {
      setPrice(data.data.priceUsd);
    }
    if (data?.data?.newInformation) {
      setChange(data.data.newInformation[`priceChange24h`]);
    }
    if (!scanData) return;
      const entries = Object.values(scanData);
    if (!entries.length) return;
      const firstScanner = entries[0] as any; 
    if (firstScanner && Object.keys(firstScanner).length > 0) {
      setScanData(firstScanner);
    }
  }, [data, priceData, scanData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Array.isArray(projectDb) && projectDb.length > 0 && projectDb[0].meta) {
          setBannerURL(projectDb[0].meta.banner);
          setLogoURL(projectDb[0].meta.logo_file);
          setLogoFormat(projectDb[0].meta.logo_format);
          setBadges(projectDb[0].meta.badges);
          setDescription(projectDb[0].meta._description);
          setIsListed(true);
          setTitle(projectDb[0].title.rendered);
          setSymbol(projectDb[0].meta.symbol);
          setVerified(projectDb[0].meta.verified)
        }
      } catch (err: any) {
        console.log(err.message);
      }
    };
  
    if (projectDb) {
      fetchData();
    }
  }, [projectDb]);  

  const renderPriceChange = (change: string | number) => {
    const value = parseFloat(change as string);
    if (value > 999){
      return (
        <div className={`redgreen green`}>
          &gt;999%
        </div>
      );
    }
    const formattedValue = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const changeClass = value >= 0 ? 'green' : 'red';
    return (
      <div className={`redgreen ${changeClass}`}>
        {formattedValue}%
      </div>
    );
  };

  const renderDescription = (desc: string) => {
    if (!desc) return <>No description provided.</>;
    if (desc.length <= 200) return desc;

    return (
      <>
        {descExpanded ? desc : desc.slice(0, 140) + '...'}
        <button
          className="read-more-btn"
          style={{
            border: 'none',
            background: 'none',
            color: '#4f7097',
            cursor: 'pointer',
            marginTop: 10,
            fontSize: '0.95em',
            padding: 0,
            display: 'block'
          }}
          onClick={() => setDescExpanded((prev) => !prev)}
        >
          {descExpanded ? 'Show less' : 'Read more'}
        </button>
      </>
    );
  };
  
  return (
    <div className='project-info-wrapper'>
        <div className='token-header'>
            {bannerURL && bannerURL.startsWith('http') ? (
              <img src={bannerURL} alt='Banner'></img>
            ) : <img src={UnlistedBanner} alt='No banner found'></img>}
        </div>
        <div className="project-info">
          <div className="logo-title">
            <div className="token-logo">
              {logoURL && logoURL.startsWith('http') ? (
                <img
                  src={logoURL}
                  alt="Logo"
                  style={{
                    borderRadius: logoFormat === "Round" ? '1000px' : '5px'
                  }}
                /> ) : <img src={UnlistedLogo} alt='No logo found'></img>}
            </div>
            <div className="token-title">
              {(scanDatas && chainId ) || (title && symbol) ? (
                  <>
                    <h2>
                      {
                        title 
                          ? title 
                          : (chainId === 501424 
                            ? scanDatas.metadata?.name 
                            : scanDatas.token_name
                            )
                      }
                    </h2>
                    <div className='listing-status'>
                      <p>
                        {
                          symbol 
                            ? symbol 
                            : (chainId === 501424 
                              ? scanDatas.metadata?.symbol 
                              : scanDatas.token_symbol
                              )
                        }
                      </p>
                          {isListed ? (
                          // <div className='risk-amount low'>
                          //   <TimesIcon /> Listed
                          // </div>
                          <></>
                      ) : <div className='risk-amount medium'>
                            <UnlistedIcon /> Unlisted
                          </div>}
                        </div>
                  </>
              ) : (
                  <h2>Loading...</h2>
              )}
            </div>
          </div>
          {badges && badges?.Audited === "true" || badges?.KYC === "true" || badges?.SAFU === "true" || badges?.Based === "true" ? (
            <div className="token-badges">
              {badges["Audited"] === "true" && (
                <div className="risk-amount low">
                  <><TimesIcon /> Audited</>
                </div>
              )}
              {badges["KYC"] === "true" && (
                <div className="risk-amount low">
                  <div className='kycbadge'><KYC style={{ color: 'rgb(14, 203, 129)' }} /> KYC <span className='byPartner'>verified</span></div>
                </div>
              )}
              {badges["SAFU"] === "true" && (
                <div className="risk-amount low">
                  <><TimesIcon style={{ color: 'rgb(14, 203, 129)' }} /> SAFU</>
                  </div>
              )}
              {badges["Based"] === "true" && (
                <div className="risk-amount low">
                  <><TimesIcon style={{ color: 'rgb(14, 203, 129)' }} /> Based</>
                </div>
              )}
                {verified === "true" ? (
                  <div className="risk-amount verified">
                    <><Verified /> Verified</>
                  </div>
                ) : (<div className="risk-amount medium">
                  <InfoIcon /> Not verified
                </div>)}
            </div>
          ) : <div className="token-badges">
                <div className="risk-amount medium">
                  <InfoIcon /> Not audited
                </div>
                {verified === "true" ? (
                  <div className="risk-amount verified">
                    <><Verified /> Verified</>
                  </div>
                ) : (<div className="risk-amount medium">
                  <InfoIcon /> Not verified
                </div>) }
              </div>}

          {price > 0 && change !== null && (
            <div className="token-price">
              <div className="price-token">${price.toFixed(9)}</div>
              <div className="token-pricechange">{renderPriceChange(change)}</div>
            </div>
          )}

          {projectDb[0]?.meta && (
          <div className="socials"><a target='_blank' href={projectDb[0].meta.telegram}><TG /></a><a target='_blank' href={projectDb[0].meta.x__twitter}><X /></a><a target='_blank' href={projectDb[0].meta.website}><WWW /></a></div>
          )}

          {description && (
            <>
              <div className='description'>
                <p>{renderDescription(description)}</p>
              </div>
            </>
          )}

            <div className="data-sep">
              <div className="data-item">
                Contract Address
              </div>
              <div className="data-item">
                <AddressDisplay address={ca} chainId={chainId} />
              </div>
            </div>
            {pairAddress && (
            <div className="data-sep">
              <div className="data-item">
                Pair Address
              </div>
              <div className="data-item">
                <AddressDisplay address={pairAddress} chainId={chainId} />
              </div>
            </div>
            )}
          </div>
    </div>
  );
};

export default ProjectInfo;
